export const porkData = [
    {
        performanceProgress: 'ปริมาณขาย',
        quantity: 'ตัน',
        January: '39,336',
        February: '36,691',
        March: '41,644',
        April: '41,084',
        May: '38,907',
        June: '39,745',
        July: '41,175',
        August: '44,475',
        September: '43,011',
        October: '43,839',
        November: '44,654',
        December: '48,804',
        total: '503,374',
    },
    {
        performanceProgress: 'มูลค่าขาย',
        quantity: 'ล้านบาท',
        January: '674',
        February: '627',
        March: '724',
        April: '734',
        May: '715',
        June: '742',
        July: '781',
        August: '856',
        September: '833',
        October: '856',
        November: '874',
        December: '951',
        total: '9,365',
    },
    {
        performanceProgress: 'ราคาขาย',
        quantity: 'บาท/ก.ก.',
        January: '17.1',
        February: '17.1',
        March: '17.4',
        April: '17.9',
        May: '18.4',
        June: '18.7',
        July: '19.0',
        August: '19.2',
        September: '19.4',
        October: '19.5',
        November: '19.6',
        December: '19.5',
        total: '18.6',
    },
    {
        performanceProgress: 'ต้นทุนรวม',
        quantity: 'บาท/ก.ก.',
        January: '(14.2)',
        February: '(14.4)',
        March: '(14.8)',
        April: '(14.8)',
        May: '(15.2)',
        June: '(16.6)',
        July: '(17.4)',
        August: '(17.5)',
        September: '(17.4)',
        October: '(17.3)',
        November: '(17.3)',
        December: '(17.4)',
        total: '(16.7)',
    },
    {
        performanceProgress: 'กำไรสุทธิ',
        quantity: 'บาท/ก.ก.',
        January: '2.9',
        February: '2.7',
        March: '2.6',
        April: '3.1',
        May: '3.2',
        June: '2.6',
        July: '2.5',
        August: '2.8',
        September: '3.2',
        October: '3.4',
        November: '3.5',
        December: '3.3',
        total: '3.0',
    },
    {
        performanceProgress: '',
        quantity: 'ล้านบาท',
        January: '115',
        February: '99',
        March: '107',
        April: '127',
        May: '124',
        June: '103',
        July: '102',
        August: '123',
        September: '138',
        October: '148',
        November: '155',
        December: '159',
        total: '1,501',
    },
    {
        performanceProgress: '',
        quantity: '%',
        January: '17.1%',
        February: '15.7%',
        March: '14.8%',
        April: '17.3%',
        May: '17.4%',
        June: '13.8%',
        July: '13.0%',
        August: '14.4%',
        September: '16.5%',
        October: '17.3%',
        November: '17.8%',
        December: '16.8%',
        total: '16.0%',
    },
]